import { useState } from 'react';
import { Button } from '../../ui/button';
import type { AuiRendererProps } from '../registry';

export function AuiButton({ node, onAction }: AuiRendererProps) {
  const props = node.component.props ?? {};
  const label = (props.label as string) ?? 'Click';
  const variant = (props.variant as 'default' | 'outline' | 'secondary' | 'ghost' | 'destructive') ?? 'default';
  const actions = node.component.actions;
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (actions?.[0] && onAction) {
      setIsLoading(true);
      try {
        await onAction(actions[0]);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <Button
      variant={variant}
      size="sm"
      onClick={handleClick}
      disabled={isLoading}
      isLoading={isLoading}
      data-testid="aui-button"
    >
      {label}
    </Button>
  );
}
